export default {"src":"/_next/static/media/checkmark_64.007a747b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};